import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Cart, CartItem, CartLocation, CartOption } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class CartHttpService {
  readonly http = inject(HttpClient);

  public getCart(id) {
    return this.http.get<Cart[]>('/cart/' + id);
  }

  public updateCart(cart, id) {
    return this.http.put<Cart>(`/cart/${id}`, cart);
  }

  public createCartLocation(location: CartLocation) {
    return this.http.post<CartLocation>('/cart_locations', location);
  }

  public getCartLocationByCart(id) {
    return this.http.get<CartLocation[]>(`/cart_locations_by_cart/${id}`);
  }

  public createCartItem(cartItem) {
    return this.http.post<CartItem>('/cart_items', cartItem);
  }

  public getCartItemsByCart(
    id,
    payload: {
      active_cart_flag?: boolean;
      active_survey_flag?: boolean;
    }
  ) {
    return this.http.post<CartItem[]>(`/cart_items_by_cart/${id}`, payload);
  }

  public getCartItemsByCartQuoteDiff(id, quote_id) {
    return this.http.get<CartItem[]>(
      `/cart_items_by_cart_quote_diff/${id}/${quote_id}`
    );
  }

  public updateCartItems(id: string, qty: string, item_status) {
    return this.http.put<CartItem>(
      `/cart_item_qty/${id}/${qty}/${item_status}`,
      ''
    );
  }

  public updateCartItemStatus(id, itemStatus) {
    return this.http.put(`/cart_update_item_status/${id}/${itemStatus}`, '');
  }

  public createCartOption(cartOption) {
    return this.http.post<CartOption>('/cart_options', cartOption);
  }

  public deleteCartOption(id) {
    return this.http.delete(`/cart_option/${id}`);
  }

  public getCartOptionsByCart(id) {
    return this.http.get<CartOption[]>(`/cart_options_by_cart/${id}`);
  }

  public deleteCartOptionsByCart(id) {
    return this.http.delete(`/cart_options_by_cart/${id}`);
  }

  public createCart(cart) {
    return this.http.post<Cart>('/carts', cart);
  }

  public getCarts(showDeadStatus) {
    return this.http.get<Cart[]>(`/carts/${showDeadStatus}`);
  }

  public getCartsPaginated(page, request) {
    return this.http.post(`/carts_paginated?page=${page}`, request);
  }

  public getCartsByCustomer(showDeadStatus, id) {
    return this.http.get<Cart[]>(`/carts_by_customer/${showDeadStatus}/${id}`);
  }

  public getCartsByActionFilter(actionFilter) {
    return this.http.post<Cart[]>('/carts_action_filter', actionFilter);
  }

  public updateCartStatus(
    id,
    due_date,
    project_status,
    item_status,
    financial_status
  ) {
    return this.http.put(
      `/cart_update_status/${id}/${due_date}/${project_status}/${item_status}/${financial_status}`,
      ''
    );
  }

  public updateCartDueDate(id, due_date) {
    return this.http.put(`/cart_update_due_date/${id}/${due_date}`, '');
  }

  public updateCartItemSupplier(id, supplier) {
    return this.http.put<CartItem>(`/cart_item_supplier/${id}/${supplier}`, '');
  }

  public updateCartProjectStatus(id, project_status) {
    return this.http.put(
      `/cart_update_project_status/${id}/${project_status}`,
      ''
    );
  }

  public updateCartSoldBy(id, user) {
    return this.http.put(`/cart_update_sold_by/${id}/${user}`, '');
  }

  public updateCartManagedBy(id, user) {
    return this.http.put(`/cart_update_managed_by/${id}/${user}`, '');
  }

  // TODO - To be DELETED (not used)
  public updateCartNoItems(id, noItems) {
    return this.http.put(`/cart_update_no_items/${id}/${noItems}`, '');
  }

  // TODO - To be DELETED (not used)
  public updateCartItemLength(id, length) {
    return this.http.get(`/cart_update_item_length/${id}/${length}`);
  }
}
